import {getAllBySelector, getBySelector} from "@/helpers/element-helper";
import {updateBackgroundSliderValue} from "@/modules/ol/ol-background-switcher.js";
import {getScaleFromResolution} from "@/helpers/print/print-scales-helper.js";
import {getViewProjection} from "@/helpers/ol/ol-projection-helper.js";

/**
 * Set view resolution
 * @param minResolution
 * @param maxResolution
 */
export function setViewResolution(minResolution, maxResolution) {

    let resolution = scaleToResolution(maxResolution) - 0.5
    if((scaleToResolution(minResolution)) > window.view.getResolution()) {
        resolution = scaleToResolution(minResolution) + 0.5
    }
    window.view.setResolution(resolution)
}

/**
 * Get view resolution scale
 * @returns {number}
 */
export function getViewResolutionScale() {
    const resolution = window.map.getView().getResolution()
    return getScaleFromResolution(resolution, 'm')
}

/**
 * Set layer by view resolution
 * @param resolution
 */
export function setLayerByViewResolution(resolution = undefined) {
    if(!resolution) {
        resolution = window.map.getView().getResolution()
    }

    getAllBySelector('layer-menu-active-item-zoom-scale').forEach(zoomToScaleElement => {
        let layerScaleName
        if(zoomToScaleElement) {
            layerScaleName = zoomToScaleElement.dataset.id
        }

        window.map.getLayers().forEach(layer => {
            const visible =  !layer.getVisible() || (
                resolution >= layer.getMinResolution() &&
                resolution < layer.getMaxResolution());

            let name = layer.get('name')

            if(name.includes('layer-') && !name.includes('layer-temporary')) {
                name = name.replace('layer-', '')

                const backgroundLayer = window.settings.backgroundLayers.find(backgroundLayer => backgroundLayer.BookmarkPresentationID === parseInt(name))
                if(backgroundLayer && visible && backgroundLayer.BookmarkGroupID && backgroundLayer.Legend) {
                    // Set background legend
                    const backgroundLayerElement = document.querySelector('.ol-switch-layer[data-group-id="' + backgroundLayer.BookmarkGroupID + '"] button')
                    if(backgroundLayerElement) {
                        backgroundLayerElement.style.backgroundImage = 'url("' + backgroundLayer.Legend + '")'
                    }
                    updateBackgroundSliderValue(name)
                }

                const elements = document.querySelectorAll('layer-menu-group-item[data-id="' + name + '"], layer-menu-active-item[data-id="' + name + '"]')

                if(name === layerScaleName) {
                    if (visible) {
                        zoomToScaleElement.classList.add('d-none')
                    } else {
                        zoomToScaleElement.classList.remove('d-none')
                    }
                }

                elements.forEach(element => {

                    const layerMenuGroupMerged = element.closest('layer-menu-group')

                    if(layerMenuGroupMerged && layerMenuGroupMerged.children && layerMenuGroupMerged.children[0].tagName === 'LAYER-MENU-GROUP-MERGED') {
                        element = layerMenuGroupMerged
                    }

                    const layerMenuButtonZoomScale = element.querySelector('layer-menu-button-zoom-scale')
                    if(layerMenuButtonZoomScale && layerMenuButtonZoomScale.classList) {
                        if (visible) {
                            layerMenuButtonZoomScale.classList.add('d-none')
                        } else {
                            layerMenuButtonZoomScale.classList.remove('d-none')
                        }
                    }
                })
            }
        })
    })
}

/**
 * Convert scale to resolution (meters per pixel)
 * @param scale
 * @param dpi
 * @returns {number}
 */
export function scaleToResolution(scale, dpi = 90.714) {
    const projection = getViewProjection()
    const metersPerUnit = projection ? projection.getMetersPerUnit() || 1 : 1;
    const result = (scale * 0.0254) / (dpi * metersPerUnit);
    return isNaN(result) ? undefined : result;
}